import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import ShiftPasswordItem from './ShiftPasswordItem'
import { HelpLink } from '../../../../../components/generic'
import { SUPPORT_LINK } from '../components/constants'

const ShiftPasswordsList = ({ shifts, onDelete }) => {
  const headings = ['Title', 'Start / End', 'Access Time', 'Actions']

  return (
    <div>
      <div style={styles.headingsContainer}>
        {headings.map((heading, i) => (
          <div key={i} style={styles.heading}>
            {heading}
          </div>
        ))}
      </div>
      <div style={styles.subDivider} />
      <ul style={styles.list}>
        {shifts?.map((shift) => (
          <div key={shift.id} className="lmc-list-item">
            <ShiftPasswordItem shift={shift} onDelete={onDelete} />
            <div style={styles.subDivider} />
          </div>
        ))}
      </ul>
      <div style={{ paddingTop: 10 }}>
        <HelpLink supportLink={SUPPORT_LINK} style={styles.helpLink} />
      </div>
    </div>
  )
}

const styles = {
  heading: {
    width: '25%',
    minWidth: 70,
    fontWeight: 300,
    fontSize: 20,
    color: colors.darkgrey,
  },
  headingsContainer: {
    width: '100%',
    minWidth: 290,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  helpLink: {},
  list: {
    listStyle: 'none',
    listStyleType: 'none',
    padding: 0,
  },
  noShiftsMessage: {
    position: 'relative',
    top: 50,
  },
  subDivider: {
    backgroundColor: colors.grey,
    height: 2,
    marginTop: 8,
  },
}

ShiftPasswordsList.propTypes = {
  shifts: PropTypes.array,
  onDelete: PropTypes.func.isRequired,
}

export default ShiftPasswordsList
